import Chip, { IChipProps } from '@srm/ui/chip';
import clsx from 'clsx';
import UserHoverCard from '@molecules/UserHoverCard/UserHoverCard';

import './AbookChipItem.scss';

export interface IAbookChipItemProps extends Omit<IChipProps, 'children' | 'onRemove'> {
    /** Значение */
    item?: string;
    /** Ключ адресной книги элемента — при наличии чип получает hover-карточку контактов */
    userKey?: string;
    /** Показывать иконку удаления
     * @default true
     */
    showRemoveIcon?: boolean;
    /** Функция удаления элемента */
    onRemove?: (item: string) => void;
    /** Класс */
    className?: string;
}

const AbookChipItem = ({
    item,
    userKey,
    showRemoveIcon = true,
    onRemove,
    className,
    ...props
}: IAbookChipItemProps) => {
    if (!item) {
        return null;
    }

    const chip = (
        <div className={clsx('rf-abookchipitem', className)}>
            <Chip
                size="sm"
                variant="outline"
                maxLength={30}
                tooltipBackground={'white'}
                onRemove={showRemoveIcon ? () => onRemove?.(item) : undefined}
                iconPosition="right"
                {...props}
            >
                {item}
            </Chip>
        </div>
    );

    return userKey ? (
        <UserHoverCard userKey={userKey} fallbackName={item}>
            {chip}
        </UserHoverCard>
    ) : (
        chip
    );
};

export default AbookChipItem;
